import { Box } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import { InternationalPhone } from 'views/common/components/Logical/InternationalPhone';

const StyledBox = styled(Box)(({ theme }) => ({
    '& .FSWrapper': {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(1.5),
        padding: theme.spacing(4),
        width: '100%',
        border: `1px solid ${theme.palette.grey[600]}`,
        [theme.breakpoints.down('lg')]: {
            padding: theme.spacing(3),
            maxWidth: '100%',
        },
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2),
        },
    },
    '& .FSHeader': {
        color: theme.palette.common.white,
        marginBottom: theme.spacing(3),
        textTransform: 'uppercase',
    },
    '& .FSFormInput': {
        '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.background.secondary,
            borderRadius: theme.spacing(0.5),
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.grey[600],
            },

        },
        '& .MuiOutlinedInput-input': {
            fontSize: theme.spacing(2),
            '&::placeholder': {
                color: theme.palette.text.secondary,
                opacity: 1,
            },
        },
        '& .MuiInputLabel-root': {
            color: `${theme.palette.text.secondary} !important`,
            fontSize: theme.spacing(2),
        },
        '& .FSPhoneLabel': {
            color: theme.palette.text.secondary,
            fontSize: theme.spacing(2),
            marginBottom: theme.spacing(0.5),
            display: 'block',
        },
        '& .FSPhoneError': {
            color: theme.palette.error.main,
            fontSize: theme.spacing(1.5),
            marginTop: theme.spacing(0.5),
            display: 'block',
        },
    },
    '& .FSDivider': {
        height: '1px',
        background: theme.palette.border[1],
        margin: theme.spacing(4, 0),
    },
    '& .FSDetailsTitle': {
        margin: theme.spacing(4, 0, 2),
        color: theme.palette.common.white,
        fontWeight: 700,
    },
    '& .FSCheckBox': {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
        display: 'flex',
        alignItems: 'flex-start',
        color: theme.palette.common.white,
        '& .FSCheckIcon': {
            paddingTop: theme.spacing(0.01),
            borderColor: theme.palette.common.white,
        },
        [theme.breakpoints.down('md')]: {
            alignItems: 'center',
            marginLeft: theme.spacing(0.1),
        },
    },
    '& .FSSendBtnContainer': {
        textAlign: 'end',
        '& .FSSendBtn': {
            minWidth: theme.spacing(21.25),
            padding: theme.spacing(1.75, 2)
        },
    },
    '& .FSReadAgreed': {
        fontSize: theme.spacing(2),
    },
    '& .FSPrivacyLink': {
        textDecoration: 'underline',
        fontSize: theme.spacing(2),
        color: theme.palette.common.white,
        fontWeight: 400,
    },
}));

export const StyledInternationalPhone = styled(InternationalPhone)(
    ({ theme }) => ({
        '&.IPphoneNumber': {
            '& .intl-tel-input.allow-dropdown': {
                '& input[type="tel"]': {
                    backgroundColor: 'transparent',
                    color: theme.palette.common.white,
                    height: theme.typography.pxToRem(56),
                    borderRadius: theme.spacing(0.5),
                    borderColor: `${alpha(theme.palette.common.white, 0.5)} !important`,
                    width: '100%',
                    paddingLeft: theme.typography.pxToRem(88),
                    fontSize: theme.typography.pxToRem(16),

                    '&:focus-visible,&:focus': {
                        borderBottom: '1px solid',
                    },
                },

                '& .country-list': {
                    border: `1px solid ${theme.palette.divider[7]}`,
                    backgroundColor: theme.palette.background.secondary,
                    boxShadow: '0px 0px 20px 0px rgba(255, 255, 255, 0.15)',
                    borderRadius: theme.spacing(1),
                    maxWidth: '100%',
                    maxHeight: theme.typography.pxToRem(300),
                    whiteSpace: 'wrap',
                    '& .divider': {
                        borderBottomColor: theme.palette.divider[7],
                    },
                    '&:first-child': {
                        padding: 500,
                    },
                },
                '& .selected-flag': {
                    borderRightColor: theme.palette.divider[7],
                    '& .arrow': {
                        color: theme.palette.text.secondary,
                    },
                },
            },
            '& .IPinvalid': {
                color: theme.palette.error.main,
                fontFamily: theme.typography.fontFamily,
                fontSize: theme.spacing(1.5),
                marginTop: 2,
                fontWeight: 500,
            },
        },
    }),
);

export { StyledBox };

